
import { defineComponent, PropType } from 'vue'
import { iFont, iStyle } from '../KpiDocumentDesigner'
import Card from 'primevue/card'
import ColorPicker from 'primevue/colorpicker'
import Dropdown from 'primevue/dropdown'
import KpiDocumentDesignerStyleCardDescriptor from './KpiDocumentDesignerStyleCardDescriptor.json'

export default defineComponent({
    name: 'kpi-edit-style-card',
    components: { Card, ColorPicker, Dropdown },
    props: { propStyle: { type: Object as PropType<iStyle>, required: true } },
    data() {
        return {
            KpiDocumentDesignerStyleCardDescriptor,
            font: null as iFont | null
        }
    },
    watch: {
        propStyle() {
            this.loadFont()
        }
    },
    created() {
        this.loadFont()
    },
    methods: {
        loadFont() {
            this.font = this.propStyle?.font as iFont
        },
        getDropdownValueLabel(value: string, options: { value: string; label: string }[]) {
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === value) {
                    return this.$t(options[i].label)
                }
            }
        }
    }
})
